export const AW_CORRELATION_MATRIX_API_URL =
  process.env?.AWAPI_AWCORRELATIONMATRIX_URL || '/api/wealth/analytics/correlation-matrix/v1';
